module.exports = __webpack_public_path__ + "8ebfb1c08431b83440691399f67e26e0.svg";